/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys, mutationKeys } from "./queryKeys";
import { invalidateAvailability } from "./invalidateAvailability";

export const useCreateBooking = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: mutationKeys.createBooking,
    mutationFn: (data) => fetcher({ method: "POST", url: "/public/booking/item/", data }),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.booking.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.client.bookingsAll });
      invalidateAvailability(queryClient);

      queryClient.invalidateQueries({ queryKey: queryKeys.waitingList.all });

      if (variables?.client_membership_id) {
        queryClient.invalidateQueries({ queryKey: queryKeys.purchasedMemberships.all });
      }
    },
  });
};
